module.exports = __webpack_public_path__ + "static/media/Offer.d1aaecc9.svg";